<template>
  <div class="container">
    <div :class="{ 'pb-24': isMobileDevice }">
      <h1 class="heading-1">{{ negativeReviewPromptHeader }}</h1>
      <div class="spacer"></div>
      <p class="mb-6">{{ negativeReviewPromptBody }}</p>
      <TextAreaField
        v-model="userReview"
        :label="$t('reviewForm.yourReview')"
        :max-length="500"
        :rows="10"
      />
      <div
        class="mt-10"
        :class="{
          'fixed bottom-0 left-0 py-4 px-6 w-full bg-white shadow-pinned-bottom-bar':
            isMobileDevice,
        }"
      >
        <Button
          :label="$t('reviewForm.button')"
          :disabled="!userReview"
          block
          @click="sendReview"
        />
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { Component, Vue } from 'vue-property-decorator';
import TextAreaField from '@/components/legacy/TextAreaField.vue';
import Button from '@/components/legacy/Button.vue';
import { ReviewsService } from '@/services/reviews.service';
import isMobile from '@/utils/isMobile';

@Component({
  components: {
    TextAreaField,
    Button,
  },
})
export default class ReviewView extends Vue {
  private userReview: string = '';
  private isMobileDevice: boolean = isMobile();

  private get negativeReviewPromptHeader(): string {
    return this.$store.getters['negativeReviewPromptHeader'];
  }
  private get negativeReviewPromptBody(): string {
    return this.$store.getters['negativeReviewPromptBody'];
  }
  private async sendReview() {
    const id = this.$store.state['reviewId'];
    if (id) {
      try {
        await ReviewsService.sendOpinion(this.userReview, id);
        this.$router.push({ name: 'negative' });
      } catch (err) {
        this.$router.push({ name: 'error' });
      }
    } else {
      this.$router.push({ name: 'error' });
    }
  }
}
</script>
